module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_2_m.3a1b99c85d76a5f95f0f8b458fc0cf5b.png";